import { z } from 'zod';
import { defineEndpoint } from '../define';

export const unlinkPlanRelease = defineEndpoint({
  method: 'DELETE',
  path: '/v1/release-plans/:planId/releases/:releaseId',
  params: z.object({ planId: z.string().uuid(), releaseId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({}),
  successStatus: 204,
});
